const style = getComputedStyle(document.documentElement);

// this function returns the hex code value of a PerformYard Color
// ex: getColor('primary', 5) returns #1676B0
export const getColor = (
	color: "primary" | "green" | "red" | "orange" | "yellow" | "pale-yellow" | "neutral",
	shade: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
): string => {
	return style.getPropertyValue(`--py-${color}-${shade}`).trim();
};

export const stringToColor = (str: string) => {
	const ctx = document.createElement("canvas").getContext("2d")!;

	ctx.fillStyle = str;

	return ctx.fillStyle;
};
